import React from "react"
import FadeLink from "../../components/fadeLink/fadeLink"

import {
  buttonPrimary,
  buttonSecondary,
  buttonTertiary,
  buttonGhost,
} from "./button.module.sass"

const Button = ({ matchWidth, external, download, type, link, children }) => {
  return external ? (
    <a href={link} download={download}>
      <button
        className={
          type === "primary"
            ? buttonPrimary
            : type === "secondary"
            ? buttonSecondary
            : type === "tertiary"
            ? buttonTertiary
            : type === "ghost"
            ? buttonGhost
            : ""
        }
        style={matchWidth ? { width: "12rem" } : {}}
      >
        {children}
      </button>
    </a>
  ) : (
    <FadeLink to={link}>
      <button
        className={
          type === "primary"
            ? buttonPrimary
            : type === "secondary"
            ? buttonSecondary
            : type === "tertiary"
            ? buttonTertiary
            : type === "ghost"
            ? buttonGhost
            : ""
        }
        style={matchWidth ? { width: "12rem" } : {}}
      >
        {children}
      </button>
    </FadeLink>
  )
}

export default Button
